// // 侧边栏

const asideMenuConfig = [
//   {
//     name: '概览',
//     path: '/',
//     icon: 'icon-gaishu',
//   },
//   {
//     name: '门店分析',
//     path: '/analysis',
//     icon: 'icon-fdaohang-fenxi',
//   },
//   {
//     name: '门店预测',
//     path: '/predict',
//     icon: 'icon-a-daohang-yuce',
//   },
//   {
//     name: '门店对比',
//     path: '/stores/contrast',
//     icon: 'icon-a-daohang-duibi',
//   },
//   {
//     name: '数据报表',
//     path: '/report/manage',
//     icon: 'icon-a-daohang-baobiao',
//   },
//   {
//     name: '门店管理',
//     path: '/stores/manage',
//     icon: 'icon-daohang-mendian',
//   },
//   // 2.1.8不做员工管理，放在后台
//   // {
//   //   name: '员工管理',
//   //   path: '/employee/manage',
//   //   icon: 'icon-daohang-yuangong',
//   // },
//   {
//     name: '订单管理',
//     path: '/order/manage',
//     icon: 'icon-daohanglan-dingdan',
//   },
];

// //  本地开发时，如果接口还未添加对应的菜单，可在此配置进行本地开发
const devMenu: Array<any> = [
  {
    name: '本地开发',
    encode: 'dev',
    icon: 'icon-a-daohang-duibi',
    uri: '/dev',
    sortNum: '1',
    parent: null,
    children: [
      // {
      //   name: '商圈规划',
      //   encode: 'yht:plan',
      //   uri: '/yht/areaplan',
      //   icon: null,
      //   parent: {
      //     name: '本地开发',
      //     encode: 'dev',
      //     icon: 'icon-a-daohang-duibi',
      //     uri: '/dev',
      //     sortNum: '1',
      //     parent: null,
      //   },
      // },
      {
        name: '品牌运营',
        encode: 'decision:brand',
        uri: '/decision/brand',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '单店详情',
        encode: 'decision:storesingle',
        uri: '/decision/storesingle',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '机会点审批',
        encode: 'decision:approvals',
        uri: '/decision/approvals',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '机会点',
        encode: 'decision:opportunities',
        uri: '/decision/opportunities',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '拓店任务',
        encode: 'decision:tasks',
        uri: '/decision/tasks',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '机会点测评',
        encode: 'decision:oppdetail',
        uri: '/decision/oppdetail',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '地图hook',
        encode: 'dev:amap',
        uri: '/dev/amap',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '地图导航',
        encode: 'dev:mapnavigation',
        uri: '/dev/mapnavigation',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '聚合demo',
        encode: 'dev:group',
        uri: '/dev/group',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '组件测试',
        encode: 'com:test',
        uri: '/dev/comtest',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      {
        name: '审批流引擎',
        encode: 'flow:engine',
        uri: '/dev/flowengine',
        icon: null,
        parent: {
          name: '本地开发',
          encode: 'dev',
          icon: 'icon-a-daohang-duibi',
          uri: '/dev',
          sortNum: '1',
          parent: null,
        },
      },
      // {
      //   name: '等时圈',
      //   encode: 'dev:isochronous',
      //   uri: '/dev/isochronous',
      //   icon: null,
      //   parent: {
      //     name: '本地开发',
      //     encode: 'dev',
      //     icon: 'icon-a-daohang-duibi',
      //     uri: '/dev',
      //     sortNum: '1',
      //     parent: null,
      //   },
      // },
    ],
  },
];
export { asideMenuConfig, devMenu };
